import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldIcon, ScrollTextIcon, Trash2Icon } from 'lucide-react';
const links = [{
  to: '/privacy-policy',
  title: 'Política de Privacidad',
  description: 'Cómo recopilamos, usamos y protegemos tu información.',
  icon: ShieldIcon
}, {
  to: '/terminos-y-condiciones',
  title: 'Términos y Condiciones',
  description: 'Condiciones de uso del sitio y de nuestros servicios.',
  icon: ScrollTextIcon
}, {
  to: '/eliminacion-de-datos',
  title: 'Eliminación de Datos',
  description: 'Cómo solicitar la eliminación de tus datos personales.',
  icon: Trash2Icon
}];
export function LegalIndex() {
  return <main className="w-full min-h-full bg-slate-50 text-slate-900" data-id="element-50">
      <div className="max-w-3xl mx-auto px-6 py-16 sm:py-20" data-id="element-51">
        <header className="mb-10" data-id="element-52">
          <p className="text-sm uppercase tracking-wider text-slate-500 mb-3" data-id="element-53">
            Legal
          </p>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900" data-id="element-54">
            Real en línea — Centro Legal
          </h1>
          <p className="mt-4 text-slate-600 leading-relaxed" data-id="element-55">
            Consulta nuestros documentos legales y de privacidad.
          </p>
        </header>

        <ul className="space-y-3" data-id="element-56">
          {links.map(({
          to,
          title,
          description,
          icon: Icon
        }) => <li key={to} data-id="element-57">
              <Link to={to} className="flex items-start gap-4 p-5 bg-white border border-slate-200 rounded-xl hover:border-slate-300 hover:shadow-sm transition-all" data-id="element-58">
                <span className="flex-shrink-0 w-10 h-10 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center" data-id="element-59">
                  <Icon className="w-5 h-5" aria-hidden="true" data-id="element-60" />
                </span>
                <div data-id="element-61">
                  <p className="font-semibold text-slate-900" data-id="element-62">{title}</p>
                  <p className="text-sm text-slate-600 mt-0.5" data-id="element-63">{description}</p>
                </div>
              </Link>
            </li>)}
        </ul>

        <footer className="mt-12 pt-6 border-t border-slate-200 text-xs text-slate-500" data-id="element-64">
          © {new Date().getFullYear()} Real en línea. Todos los derechos
          reservados.
        </footer>
      </div>
    </main>;
}